export const innerBlurBackgroundColor = "rgba(0, 0, 0, 0.7)";
export const outerBlurStyle = {
	backgroundColor: "rgba(0, 0, 0, 0.5)",
	backdropFilter: "blur(10px)",
	WebkitBackdropFilter: "blur(10px)",
};
